module.exports = __webpack_public_path__ + "AvertaStd-Bold.svg?783e7e878f07149c322075437c90aa45";